<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>BBEFrance - Tableau de bord {{ version }}</span>
    <span class="flex-1"></span>
    <button mat-button routerLink="/utilisateurs" routerLinkActive="active" *ngIf="isLoggedIn$ | async">
      <mat-icon class="mx-1">people</mat-icon>
      Salariés
    </button>
    <button mat-button routerLink="/projets" routerLinkActive="active" *ngIf="isLoggedIn$ | async">
      <mat-icon class="mx-1">work</mat-icon>
      Projets
    </button>
    <button mat-button (click)="onLogout()" *ngIf="isLoggedIn$ | async">
      <mat-icon class="mx-1">power_settings_new</mat-icon>
      Déconnexion
    </button>
  </mat-toolbar-row>
</mat-toolbar>
